/**
 * @generated SignedSource<<8efbbb731fa1ea2ca09e6d24c3722210>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateDraftQuoteInput = {
  activeABTests?: ReadonlyArray<ABTestVariantInput> | null;
  contactSubmittedAt?: any | null;
  finalQuoteId?: string | null;
  gclid?: string | null;
  id: string;
  language?: string | null;
  lastStep?: string | null;
  lastStepAt?: any | null;
  leadOrigin?: string | null;
  leadOriginFirst?: string | null;
  leadOriginHistory?: any | null;
  leadOriginLast?: string | null;
  procedureDescription?: string | null;
  selectedLocation?: string | null;
  selectedProcedureTypes?: ReadonlyArray<string> | null;
  selectedProceduresV2?: ReadonlyArray<string> | null;
  selectedSurgeon?: string | null;
  startedAt?: any | null;
  trackingIds?: any | null;
};
export type ABTestVariantInput = {
  testId: string;
  testName?: string | null;
  variant: string;
  weight?: number | null;
};
export type QuoteProviderUpdateDraftQuoteMutation$variables = {
  input: UpdateDraftQuoteInput;
};
export type QuoteProviderUpdateDraftQuoteMutation$data = {
  readonly updateDraftQuote: {
    readonly id: string;
  };
};
export type QuoteProviderUpdateDraftQuoteMutation = {
  response: QuoteProviderUpdateDraftQuoteMutation$data;
  variables: QuoteProviderUpdateDraftQuoteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DraftQuote",
    "kind": "LinkedField",
    "name": "updateDraftQuote",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QuoteProviderUpdateDraftQuoteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QuoteProviderUpdateDraftQuoteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "346dbd2038923def482d91bce446523b",
    "id": null,
    "metadata": {},
    "name": "QuoteProviderUpdateDraftQuoteMutation",
    "operationKind": "mutation",
    "text": "mutation QuoteProviderUpdateDraftQuoteMutation(\n  $input: UpdateDraftQuoteInput!\n) {\n  updateDraftQuote(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "14a4b107da5b8d4cc544a67073855ac2";

export default node;
